import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';
import { ReactNode } from 'react';

import { Icon } from '@growtherapy/sprout-ui';

export function FormListItemContent({ title, subtitle }: { title: ReactNode; subtitle?: ReactNode }) {
  return (
    <div className='flex grow justify-between'>
      <div>
        {title}
        {subtitle}
      </div>
      <Icon aria-hidden icon={faAngleRight} className='mr-2 self-center text-text-inverse' />
    </div>
  );
}
